module.exports = __webpack_public_path__ + "media/images/png/refund-528d9f7d20181734d2eac7f9ff59672b.png";